import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import setAuthCredentials from '../../setAuthCredentials';

const AuthLoginByRouteComponent = ({ userDataOnDemand }) => {
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setAuthCredentials(token);
    loadUserData();
  }, []);

  const loadUserData = async () => {
    const response = await userDataOnDemand();
    if (response) {
      navigate('/');
    }
  };

  return null;
};

AuthLoginByRouteComponent.propTypes = {
  userDataOnDemand: PropTypes.func.isRequired,
};

export default AuthLoginByRouteComponent;
